import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=36ae92cb"
import script from "./scroll-to-top.vue?vue&type=script&lang=js"
export * from "./scroll-to-top.vue?vue&type=script&lang=js"
import style0 from "./scroll-to-top.vue?vue&type=style&index=0&id=36ae92cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports